export abstract class BaseResourceModel {
    
    constructor(
        public id?: number
    ) {}
}
